<template>
  <b-container class="mt-3">

    <b-row class="mb-3">
      <b-col cols="8">
        <h1 class="mb-4">Clients</h1>
        <p>Create an OpenId Connect app via the OneLogin Administration portal and then add the <b>Client ID</b> and <b>Client Secret</b> here.</p>
        <p>When creating your OpenId Connect app be sure to add</p>
        <p><b>{{ redirectURI }}</b></p>
        <p>to the allowed Redirect Uris list on the Configuration tab.</p>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-btn v-b-modal.clientDetail variant="primary">Add Client</b-btn>
      </b-col>
    </b-row>

    <b-alert variant="danger" show>
      <p>
        This client is used for testing flows and inspecting token values so it requires
        that you enter your <b>Client Secret</b>.
      </p>
      <p>
        You <b>MUST</b> generate a new client secret when you're finished working with this inspector.
      </p>
    </b-alert>

    <b-card v-for="client in clients" v-bind:key="client.ID" :title="client.name"
            tag="article"
            class="mb-2">
      <p class="card-text">
        <b>Client ID: </b> {{client.ID}}
      </p>
      <p class="card-text">
        <b>Client Secret: </b> {{client.secret}}
      </p>
      <b-button type="button" variant="danger" v-on:click="removeClient(client.ID)">Remove</b-button>
    </b-card>



    <!-- Modal Component -->
    <b-modal id="clientDetail" title="Add a new OIDC client" @ok="createClient">
      <b-form-group>
        <b-form-input id="clientName"
                      type="text"
                      required
                      v-model="clientName"
                      placeholder="Name for this OIDC client">
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input id="clientID"
                      type="text"
                      required
                      v-model="clientID"
                      placeholder="Enter OIDC Client ID">
        </b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input id="clientSecret"
                      type="text"
                      required
                      v-model="clientSecret"
                      placeholder="Enter OIDC Client Secret">
        </b-form-input>
      </b-form-group>
    </b-modal>

  </b-container>
</template>

<script>
export default {
  data () {
    return {
      clients: [],
      clientName: '',
      clientID: '',
      clientSecret: '',
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'ID', label: 'Client ID' },
        { key: 'secret', label: 'Client Secret' },
        { key: 'actions', label: '' }
      ],
      redirectURI: window.location.origin + '/openid-connect/inspector'
    }
  },
  mounted() {
    if (localStorage.clients) {
      this.clients = JSON.parse(localStorage.clients);
    }

    this.reset()
  },
  methods: {
    reset: function () {
      this.clientName = '';
      this.clientID = '';
      this.clientSecret = '';
    },

    createClient: function(event) {
      this.clients.push({
        name: this.$sanitize(this.clientName),
        ID: this.clientID,
        secret: this.clientSecret
      });

      localStorage.clients = JSON.stringify(this.clients);

      this.reset()
    },

    removeClient: function(clientID) {
      console.log('Remove ClientID ', clientID);

      for(let i=0; i<this.clients.length; i++){
        let client = this.clients[i];
        if(client.ID == clientID){
          this.clients.splice(this.clients.indexOf(client), 1)
        }
      }

      localStorage.clients = JSON.stringify(this.clients);
    }
  }
}
</script>

<style>
</style>
